// extracted by mini-css-extract-plugin
export var infoItem = "_r4-2";
export var title = "_r4-0";
export var value = "_r4-1";